import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["locationSelect", "assistantSelect", "reportsToSelect"]

  connect() {

    console.log("Contacts Stimulus controller connected")

    const customerSelect = this.element.querySelector("#floatingCust")

    if (customerSelect && customerSelect.value) {

      this.loadLocations({ target: customerSelect })

    }

  }

  async loadLocations(event) {
    const customerId = event.target.value

    if (!customerId) {
      this.clearOptions(this.locationSelectTarget)
      this.clearOptions(this.assistantSelectTarget)
      this.clearOptions(this.reportsToSelectTarget)
      return
    }

    const response = await fetch(`/customers/${customerId}/contacts_data`)
    const data = await response.json()

    this.updateOptions(this.locationSelectTarget, data.locations)
    this.updateOptions(this.assistantSelectTarget, data.assistants)
    this.updateOptions(this.reportsToSelectTarget, data.contacts)
  }

  updateOptions(selectElement, items) {
    const selectedValue = selectElement.dataset.selected

    selectElement.innerHTML = '<option value="">Bitte wählen</option>'

    items.forEach(item => {
      const option = document.createElement("option")
      option.value = item.id
      option.textContent = item.full_address || item.name

      if (selectedValue && selectedValue == item.id) {
        option.selected = true
      }

      selectElement.appendChild(option)
    })
  }

  clearOptions(selectElement) {
    selectElement.innerHTML = '<option value="">Bitte wählen</option>'
  }
}
